(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plan-ahead"] && !Shopify.designMode) return;
  try {
    
  class PlanAhead extends HTMLElement {
    connectedCallback() {
      this.days = Array.from(this.querySelectorAll('.pa__day'));
      this.cards = Array.from(this.querySelectorAll('.pa__card'));
      if (!this.days.length) return;

      this.dropPastDays();
      if (!this.days.length) return;

      this.days.forEach((btn) => {
        btn.addEventListener('click', () => this.select(btn.dataset.date));
      });

      /* TCE patch (1 Oct 2026): ?pickup=YYYY-MM-DD (from the cart's "see what else is ready") wins
         over the busiest day. */
      let wanted = '';
      try {
        wanted = new URLSearchParams(window.location.search).get('pickup') || '';
      } catch (e) { wanted = ''; }
      const fromUrl = this.days.find((b) => b.dataset.date === wanted);
      const preferred = fromUrl ? wanted : this.dataset.default;
      const match = this.days.find((b) => b.dataset.date === preferred);
      this.select(match ? preferred : this.days[0].dataset.date);
    }

    /* Store-time "today" and minutes after midnight (not the phone's zone). */
    clock() {
      const now = new Date();
      try {
        const parts = {};
        new Intl.DateTimeFormat('en-CA', {
          timeZone: this.dataset.tz || undefined,
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
        }).formatToParts(now).forEach((p) => (parts[p.type] = p.value));
        return {
          iso: `${parts.year}-${parts.month}-${parts.day}`,
          mins: (parseInt(parts.hour, 10) % 24) * 60 + parseInt(parts.minute, 10),
        };
      } catch (e) {
        return null;
      }
    }

    /* The server already leaves out today after the cutoff. This only catches a page served
       from a cache made earlier: days before today, and today once the cutoff has passed. */
    dropPastDays() {
      const c = this.clock();
      if (!c) return;
      const cutoff = parseInt(this.dataset.cutoff || '', 10);
      this.days = this.days.filter((btn) => {
        const d = btn.dataset.date || '';
        const past = d < c.iso || (d === c.iso && Number.isFinite(cutoff) && c.mins > cutoff);
        if (past) btn.remove();
        return !past;
      });
      if (!this.days.length) {
        this.cards.forEach((card) => { card.hidden = true; });
      }
    }

    select(date) {
      this.days.forEach((btn) => {
        const on = btn.dataset.date === date;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const btn = this.days.find((b) => b.dataset.date === date);
      const c = this.clock();
      this.cards.forEach((card) => {
        const dates = (card.dataset.dates || '').split(',');
        const on = dates.indexOf(date) !== -1;
        card.hidden = !on;
        /* TCE patch (1 Oct 2026), Rec 2: carry the chosen day to the product page. */
        card.querySelectorAll('.pa__card-link, [data-pa-choose]').forEach((a) => {
          try {
            const u = new URL(a.getAttribute('href'), window.location.origin);
            u.searchParams.set('pickup', date);
            a.setAttribute('href', u.pathname + u.search);
          } catch (e) { /* keep the plain link */ }
        });
        /* Rec 3: quick add books this day + the dish's one window. Today only while that window
           can still be made after the dish's notice. */
        const qa = card.querySelector('[data-pa-qa]');
        if (!qa) return;
        let ok = on && Boolean(btn);
        if (ok && c && date === c.iso) {
          const end = parseInt(qa.dataset.end || '', 10);
          const notice = parseInt(qa.dataset.notice || '0', 10);
          ok = Number.isFinite(end) && end >= c.mins + notice;
        }
        qa.hidden = !ok;
        if (!btn) return;
        const d = qa.querySelector('[data-pa-date]');
        const dp = qa.querySelector('[data-pa-date-prop]');
        if (d) d.value = btn.dataset.value || '';
        if (dp) dp.value = btn.dataset.prop || btn.dataset.value || '';
        qa.dataset.tceAdded = (qa.dataset.addedTpl || '').replace('__DAY__', btn.dataset.label || '');
      });
    }
  }
  if (!customElements.get('plan-ahead')) {
    customElements.define('plan-ahead', PlanAhead);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ready-today"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tce-rt-clock')) {
    class TceRtClock extends HTMLElement {
      connectedCallback() {
        const section = this.closest('.rt');
        if (!section) return;
        let iso;
        let mins;
        try {
          const parts = {};
          new Intl.DateTimeFormat('en-CA', {
            timeZone: this.dataset.tz || undefined,
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
          }).formatToParts(new Date()).forEach((p) => (parts[p.type] = p.value));
          iso = `${parts.year}-${parts.month}-${parts.day}`;
          mins = (parseInt(parts.hour, 10) % 24) * 60 + parseInt(parts.minute, 10);
        } catch (e) {
          return;
        }
        const cutoff = parseInt(this.dataset.cutoff || '', 10);
        const stale = iso !== this.dataset.today || (Number.isFinite(cutoff) && mins >= cutoff);
        if (!stale) return;
        section.querySelectorAll('[data-rt-open]').forEach((el) => { el.hidden = true; });
        section.querySelectorAll('[data-rt-closed]').forEach((el) => { el.hidden = false; });
      }
    }
    customElements.define('tce-rt-clock', TceRtClock);
  }
  if (!customElements.get('tce-rt-window')) {
    /* TCE patch (1 Oct 2026): Lunch / Evening dropdown for today's quick add.
       Changing it rewrites the pickup time on every + form in the section. A dish that can't make
       the chosen window shows the › link to its page instead. If the page was cached from before
       the lunch switch hour, Lunch is removed on load. */
    class TceRtWindow extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.rt');
        this.select = this.querySelector('select');
        if (!this.section || !this.select) return;
        this.select.addEventListener('change', () => this.apply());
        try {
          const parts = {};
          new Intl.DateTimeFormat('en-CA', {
            timeZone: this.dataset.tz || undefined, hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
          }).formatToParts(new Date()).forEach((p) => (parts[p.type] = p.value));
          const mins = (parseInt(parts.hour, 10) % 24) * 60 + parseInt(parts.minute, 10);
          const sw = parseInt(this.dataset.switch || '', 10);
          if (Number.isFinite(sw) && mins >= sw) {
            const lunch = this.select.querySelector('option[value="lunch"]');
            if (lunch) lunch.remove();
            this.select.value = 'evening';
          }
        } catch (e) { /* keep the server's choice */ }
        this.apply();
      }
      apply() {
        const opt = this.select.selectedOptions[0];
        if (!opt) return;
        const key = opt.value;
        this.section.querySelectorAll('.rt__item').forEach((item) => {
          const wrap = item.querySelector('[data-rt-add]');
          const link = item.querySelector('[data-rt-link]');
          const can = wrap && wrap.dataset[key === 'lunch' ? 'canLunch' : 'canEvening'] === 'true';
          if (wrap) {
            wrap.hidden = !can;
            const t = wrap.querySelector('[data-rt-time]');
            const tp = wrap.querySelector('[data-rt-time-prop]');
            if (t) t.value = opt.dataset.value;
            if (tp) tp.value = opt.dataset.prop;
            if (opt.dataset.added) wrap.dataset.tceAdded = opt.dataset.added;
          }
          if (link) link.hidden = Boolean(can);
        });
      }
    }
    customElements.define('tce-rt-window', TceRtWindow);
  }
  if (!customElements.get('tce-rt-urgency')) {
    /* TCE patch (1 Oct 2026), Rec 5: "Order by 1:00pm for lunch · today's menu closes at 6:00pm".
       Same store-time clock as tce-rt-clock. In the last two hours before a deadline the line
       counts down. When the lunch switch passes, Lunch leaves the dropdown; when ordering for
       today closes, the section swaps to the closed message, as tce-rt-clock does on load. */
    class TceRtUrgency extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('[data-urgency-text]');
        this.tick();
        this.timer = window.setInterval(() => this.tick(), 30000);
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
      }
      clock() {
        try {
          const parts = {};
          new Intl.DateTimeFormat('en-CA', {
            timeZone: this.dataset.tz || undefined,
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
          }).formatToParts(new Date()).forEach((p) => (parts[p.type] = p.value));
          return {
            iso: `${parts.year}-${parts.month}-${parts.day}`,
            mins: (parseInt(parts.hour, 10) % 24) * 60 + parseInt(parts.minute, 10),
          };
        } catch (e) {
          return null;
        }
      }
      left(n) {
        const total = Math.max(1, n);
        const h = Math.floor(total / 60);
        const m = total % 60;
        if (h > 0) return (this.dataset.hm || '').replace('__H__', h).replace('__M__', m);
        return (this.dataset.min || '').replace('__M__', m);
      }
      tick() {
        const c = this.clock();
        const section = this.closest('.rt');
        if (!c || !section || !this.text) return;
        const closesAt = parseInt(this.dataset.closesAt || '', 10);
        if (c.iso !== this.dataset.today || (Number.isFinite(closesAt) && c.mins >= closesAt)) {
          section.querySelectorAll('[data-rt-open]').forEach((el) => { el.hidden = true; });
          section.querySelectorAll('[data-rt-closed]').forEach((el) => { el.hidden = false; });
          window.clearInterval(this.timer);
          return;
        }
        const sw = parseInt(this.dataset.switch || '', 10);
        const close = parseInt(this.dataset.close || '', 10);
        const select = section.querySelector('tce-rt-window select');
        let lunch = select ? select.querySelector('option[value="lunch"]') : null;
        if (lunch && Number.isFinite(sw) && c.mins >= sw) {
          lunch.remove();
          lunch = null;
          select.value = 'evening';
          select.dispatchEvent(new Event('change'));
        }
        let msg;
        if (lunch && Number.isFinite(sw)) {
          msg = sw - c.mins <= 120
            ? (this.dataset.lunchSoon || '').replace('__LEFT__', this.left(sw - c.mins))
            : this.dataset.lunch;
        } else if (Number.isFinite(close) && close - c.mins <= 120) {
          msg = (this.dataset.closeSoon || '').replace('__LEFT__', this.left(close - c.mins));
        } else {
          msg = this.dataset.closeText;
        }
        if (msg) this.text.textContent = msg;
      }
    }
    customElements.define('tce-rt-urgency', TceRtUrgency);
  }

  } catch(e) { console.error(e); }
})();
})();
